import React from 'react';
import { LinkProps } from 'react-router-dom';
import { StyledLink } from './NoDecoLink.styles';

const NoDecoLink = (props: LinkProps) => {
  return <StyledLink {...props} />;
};

export default NoDecoLink;
